import { usePickBlock } from 'src/utils/pick-block';

export const useShowImageBorder = (blockId: string) => {
  const block = usePickBlock(blockId, ['data'], ['format']);
  return block?.data.format?.addImageBorder;
};
